import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UserStore from "../../store/UserStore";

const SubAssetTabs = () => {
  const [assetClassTabs, setAssetClassTabs] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubClass, setselectedSubClass] = useState("");
  const [mainTabs, setMainTabs] = useState([]);
  const [mainTabIdx, setMainTabIdx] = useState(null);

  const { assetClassId, vehicleId, lastMeasureId } = useParams();

  const { vehicleId: vehiclesId, assetClassId: assetsId } =
    UserStore.selectedInstrumentVehicle;

  const handleTabSelection = (tabsData, idx) => {
    const { vehicleId } = UserStore.selectedInstrumentVehicle;
    if (vehicleId == 15 && UserStore.toggleLive) {
      UserStore.changeIsLiveOnly("0", false);
    }
    if (tabsData.id == 15 && UserStore.toggleLive) {
      UserStore.changeIsLiveOnly("1", true);
    }

    const mainData =
      mainTabIdx !== null
        ? UserStore.assetdData?.[mainTabIdx]?.allSubAssetDetails[idx]
        : UserStore.assetdData?.find(
            (assetData) => assetData?.assetId == assetClassId,
          )?.allSubAssetDetails?.[idx];
    const data = mainData.subAssetData[0];
    setselectedSubClass(mainData);
    UserStore.setSelectedInstrumentVehicle(data);
    if (!data?.modifiedVehicleData) {
      UserStore.setCallingSubAssetApi(true);
      UserStore.getVehicleDetails({
        assetClassId: data.assetClassId,
        vehicleId: data.vehicleId,
        measureId: lastMeasureId || "",
      });
    }
  };

  const handleMainTabSelection = (data, index) => {
    const { vehicleId } = UserStore.selectedInstrumentVehicle;
    if (
      data.assetId == 2 &&
      data.allSubAssetDetails[0].id == 15 &&
      UserStore.toggleLive
    ) {
      UserStore.changeIsLiveOnly("1");
    }

    if (vehicleId == 15 && UserStore.toggleLive) {
      UserStore.changeIsLiveOnly("0");
    }
    const mainData = UserStore.assetdData[index];
    const setData = mainData.allSubAssetDetails[0].subAssetData[0];
    setMainTabIdx(index);
    setSelectedClass(mainData);

    UserStore.setSelectedInstrumentVehicle(setData);
    setselectedSubClass(mainData?.allSubAssetDetails[0]);
    if (!setData?.modifiedVehicleData) {
      UserStore.setCallingSubAssetApi(true);
      UserStore.getVehicleDetails({
        assetClassId: data.assetId,
        vehicleId: data.allSubAssetDetails[0].id,
        measureId: lastMeasureId || "",
      });
    }
  };

  useEffect(() => {
    if (UserStore.assetdData.length) {
      const localArray =
        UserStore.assetdData[UserStore.assetdData.length - 1].assetId === 0
          ? [...UserStore.assetdData].slice(0, UserStore.assetdData?.length - 1)
          : [...UserStore.assetdData];
      //localArray.splice(-1);

      let classId = null;
      let subClassId = null;
      const { assetClassId: assetId, vehicleId: subAssetId } =
        UserStore.selectedInfinityInstrument;

      const { assetId: firstAssetId, subAssetId: firstSubAssetId } =
        UserStore.subAssetFirstVehicleListIds;

      if (assetId) {
        classId = assetId;
        subClassId = subAssetId;
      } else if (firstAssetId) {
        classId = firstAssetId;
        subClassId = firstSubAssetId;
      } else {
        classId = assetClassId;
        subClassId = vehicleId;
      }

      setAssetClassTabs(localArray);
      let assetData = UserStore?.assetdData?.find(
        (arr) => arr.assetId == classId,
      );
      setSelectedClass(assetData);
      setselectedSubClass(
        assetData?.allSubAssetDetails?.find(
          (eachData) => eachData?.id == subClassId,
        ),
      );
    }
  }, [UserStore.subAssetFirstVehicleListIds]);

  useEffect(() => {
    if (selectedClass) {
      setMainTabs(selectedClass.allSubAssetDetails);
    }
  }, [selectedClass]);

  return (
    <>
      {" "}
      <div
        className={`sub_asset_tab_container ${
          !UserStore.callingSubAssetApi ? "" : "no_pointer"
        }`}
      >
        <div className={`tabs home_tabs subasset_tabs`}>
          <ul>
            {assetClassTabs.map((tabsData, index) => {
              return (
                <>
                  <li
                    className={
                      tabsData.assetId === selectedClass?.assetId
                        ? `is-active `
                        : ""
                    }
                  >
                    <button
                      role="tab"
                      aria-selected={
                        tabsData.assetId === selectedClass?.assetId
                      }
                      onClick={() =>
                        assetsId != tabsData.assetId &&
                        handleMainTabSelection(tabsData, index)
                      }
                    >
                      {tabsData.assetName}
                    </button>
                  </li>
                </>
              );
            })}
          </ul>
        </div>

        <div className="tab_container">
          <div className="tabs_part portfolio_sub_asset_tabs">
            <div className="tabs port_tabs sub_asset_tabs">
              <ul>
                {mainTabs?.map((tabsData, idx) => (
                  <li
                    className={
                      selectedSubClass?.id === tabsData?.id
                        ? "is-active"
                        : "portfolio_tabs_btn_animation"
                    }
                  >
                    <button
                      role="tab"
                      aria-selected={selectedSubClass?.id === tabsData?.id}
                      onClick={() => {
                        UserStore.setFilterStatus(false);
                        vehiclesId != tabsData.id &&
                          handleTabSelection(tabsData, idx);
                      }}
                    >
                      {tabsData?.subAssetName}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {false && (
        <div
          className={`sub_asset_tab_container_tablist_wrapper ${
            !UserStore.callingSubAssetApi ? "" : "no_pointer"
          }`}
        >
          <div className={`tabs_list home_tabs_list subasset_tabs_list`}>
            <div role="tablist" className="wrapper-list">
              {assetClassTabs.map((tabsData, index) => {
                return (
                  <>
                    <div
                      // onClick={() =>
                      //   assetsId != tabsData.assetId &&
                      //   handleMainTabSelection(tabsData, index)
                      // }
                      className={
                        tabsData.assetId === selectedClass?.assetId
                          ? `is-active `
                          : ""
                      }
                    >
                      <button
                        key={tabsData.assetId}
                        role="tab"
                        aria-selected={
                          tabsData.assetId === selectedClass?.assetId
                        }
                        // tabIndex={
                        //   tabsData.assetId === selectedClass?.assetId ? 0 : -1
                        // }
                        onClick={() =>
                          assetsId != tabsData.assetId &&
                          handleMainTabSelection(tabsData, index)
                        }
                      >
                        {tabsData.assetName}
                      </button>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div className="tab_container">
            <div className="tabs_part_list portfolio_sub_asset_tabs_list">
              <div className="tabs_list port_tabs_list sub_asset_tabs_list">
                <div role="tablist" className="wrapper-list">
                  {mainTabs?.map((tabsData, idx) => (
                    <div
                      className={
                        selectedSubClass?.id === tabsData?.id
                          ? "is-active"
                          : "portfolio_tabs_btn_animation"
                      }
                      // onClick={() => {
                      //   UserStore.setFilterStatus(false);
                      //   vehiclesId != tabsData.id &&
                      //     handleTabSelection(tabsData, idx);
                      // }}
                    >
                      <button
                        key={tabsData.id}
                        role="tab"
                        aria-selected={selectedSubClass?.id === tabsData?.id}
                        // tabIndex={selectedSubClass?.id === tabsData?.id ? 0 : -1}
                        onClick={() => {
                          UserStore.setFilterStatus(false);
                          vehiclesId != tabsData.id &&
                            handleTabSelection(tabsData, idx);
                        }}
                      >
                        {tabsData?.subAssetName}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(SubAssetTabs);
